import { Component, Input} from '@angular/core';


@Component({
  selector: 'email-summarize',
  templateUrl: './email-summarize.component.html',
  styleUrls: ['./email-summarize.component.scss'],
})
export class EmailSummarizeComponent {
  @Input()
  gptSummary: string;
}


// WEBPACK FOOTER //
// ./client/app/inbox/email-summarize/email-summarize.component.ts